import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import "./InfoWidget.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
    text: string;
    icon: IconDefinition;
    variant?: "info" | "warning";
    className?: string;
}

const InfoWidget = (props: IProps) => {
    const variant = props.variant || "warning";

    return (
        <div className={`infoWidgetPassport ${variant} ${props.className ? props.className : ""}`}>
            <FontAwesomeIcon icon={props.icon} className="infoWidgetIcon" />
            <div className="infoWidgetText">{props.text}</div>
        </div>
    );
};

export default InfoWidget;
